const TONES = {
  pain: {
    border: "border-orange-200",
    bg: "bg-orange-50",
    title: "text-orange-800",
    dot: "bg-orange-500",
  },
  goal: {
    border: "border-emerald-200",
    bg: "bg-emerald-50",
    title: "text-emerald-800",
    dot: "bg-emerald-500",
  },
  cost: {
    border: "border-amber-200",
    bg: "bg-amber-50",
    title: "text-amber-800",
    dot: "bg-amber-500",
  },
  neutral: {
    border: "border-blue-200",
    bg: "bg-blue-50",
    title: "text-blue-800",
    dot: "bg-blue-500",
  },
  gold: {
    border: "border-yellow-300",
    bg: "bg-yellow-50",
    title: "text-yellow-900",
    dot: "bg-yellow-500",
  },
};

export default function CategoryCard({ tone = "neutral", title, icon: Icon, items, testId, showQuote }) {
  const t = TONES[tone] || TONES.neutral;
  return (
    <article
      data-testid={testId}
      className={`bg-white border ${t.border} rounded-xl p-5 shadow-sm h-full flex flex-col`}
    >
      <header className="flex items-center justify-between mb-3 pb-3 border-b border-slate-100">
        <div className="flex items-center gap-2">
          <span className={`h-2 w-2 rounded-full ${t.dot}`} />
          <h3 className={`font-display text-xs font-semibold uppercase tracking-widest ${t.title}`}>
            {title}
          </h3>
        </div>
        <span className="font-mono text-xs text-slate-400">{items.length}</span>
      </header>

      <ul className="space-y-2 flex-1">
        {items.length === 0 && (
          <li className="text-xs text-slate-400 italic">No items yet — listening…</li>
        )}
        {items.map((it) => (
          <li
            key={it.id}
            className={`sch-fade-in rounded-lg ${t.bg} px-3 py-2 text-sm text-slate-800 leading-snug`}
            data-testid={`${testId}-item`}
          >
            <div className="font-medium">{it.text}</div>
            {showQuote && it.quote && (
              <div className="mt-1 text-xs text-slate-600 italic line-clamp-3">
                &ldquo;{it.quote}&rdquo;
              </div>
            )}
          </li>
        ))}
      </ul>
    </article>
  );
}
